<h1 mat-dialog-title>{{ data.title | translate: data.titleParams }}</h1>
<mat-dialog-content id="dialog-content"
  >{{ data.content | translate: data.contentParams }}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button *ngIf="data.closeLabel" mat-button type="button" [mat-dialog-close]="false">
    {{ data.closeLabel | translate }}
  </button>
  <button *ngIf="data.okLabel" mat-button type="button" [mat-dialog-close]="true">
    {{ data.okLabel | translate }}
  </button>
</mat-dialog-actions>
